import React from 'react';
import { AuthRoles } from "components/auth";

export const ProductsConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/products`,
            component: React.lazy(() => import('./Products'))
        }
    ]
};